import React, {Component} from 'react'
import { css, StyleSheet } from 'aphrodite';
import { AppTheme, AppStyles } from '../../styles/AppTheme';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { NextPage } from '../components/NextPage'
import { Tooltip } from '@material-ui/core';


export class TableComponent extends Component {
  constructor(props) {
    super(props)
    // console.log(props)
  }

  renderHead() {
    const { tableHeadersMap } = this.props
    const tableHeaders = tableHeadersMap ? Object.keys(tableHeadersMap) : this.props.tableHeaders
    const cellWidths = this.props.cellWidths || {}
    return (
      <TableHead>
        <TableRow>
          <TableCell className={css([Styles.cellHead, cellWidths.actions])}>
          </TableCell>
          {tableHeaders.map((header, index) => (
            <TableCell
              className={css([Styles.cellHead, cellWidths[header]])}
              key={'headCol' + index}>{header.toUpperCase()}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    )
  }

  renderBody() {
    const { tableHeadersMap, onTableValue, items} = this.props
    const tableHeaders = tableHeadersMap ? Object.keys(tableHeadersMap) : this.props.tableHeaders
    const lastElmntIndex = this.props.tableHeaders ? this.props.tableHeaders.length - 1 : undefined;
    const cellWidths = this.props.cellWidths || {}
    return (
      <TableBody>
        {
          items.map((current, itemIndex) => {
            current.__index = itemIndex
            return (
              <TableRow key={current.id}>
                <TableCell className={css([Styles.cellBody, Styles.cellBodyIcons, cellWidths.actions])}>
                  <div className={css(Styles.divIcon)}>
                    {this.setUpActions(current, itemIndex)}
                  </div>
                </TableCell>
                {tableHeaders.map((f, headerIndex) => (
                  <TableCell key={current.id + headerIndex}
                    className={(headerIndex === lastElmntIndex) ? css([Styles.cellBody, Styles.lastcellBody, cellWidths[f]]) : css(Styles.cellBody)}
                  >
                    {tableHeadersMap ? tableHeadersMap[f](current) : onTableValue(current, headerIndex)}
                  </TableCell>
                ))}
              </TableRow>
            )
          })
        }
      </TableBody >
    )
  }

  setUpActions(current, index) {
    // this.headerActions - if any action is multi: actions.push('checkbox')
    let isMulti = false
    if (this.props.headerActions) {
      for (const action of this.props.headerActions) {
        if (action.multi) {
          isMulti = true;
          break;
        }
      }
    }

    let actions = []
    if (this.props.onActions) {
      actions = Object.assign([], this.props.onActions(current))
    }
    if (isMulti) {
      actions.push(this.addButtonCheckbox(current, index))
    }
    return actions;
  }

  addButtonCheckbox(current, index) {
    return (
      <Tooltip title='Check' placement='top-start' key={current.id + 'checkTT'}>
        <span className={css(AppStyles.entityTableLinkIcon, (current.__checked ? Styles.buttonSpanUnchecked : Styles.buttonSpanChecked))}>
          <i className='material-icons' color='blue' onClick={() => this.handleCheck(current, index)}>check_circle</i>
        </span>
      </Tooltip >
    )
  }

  handleCheck(current, index) {
    let itemsList = [];
    itemsList = Object.assign([], this.props.items)
    if (itemsList[index].__checked && itemsList[index].__checked) {
      current.__checked = false
    } else {
      current.__checked = true
    }
    this.props.setItems(itemsList)
  }

  render() {
    return (
      <div className={css(Styles.entityContent)}>
        {this.props.items.length > 0 ?
          <div className={css(Styles.divTable)}>
            <Table className={css(Styles.table)}>
              {this.renderHead()}
              {this.renderBody()}
            </Table>
          </div>
          :
          <p className={css(Styles.empty)}>{this.props.emptyText || 'Nothing to show here yet'}</p>

        }
        {this.props.nextPage &&
            (<NextPage
              nextPageState={this.props.nextPageState}
              onNext={this.props.onNext}></NextPage>)}
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  entityContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: AppTheme.viewPort,
    paddingBottom: 100,
    width: '100%',
  },
  divTable: {
    display: 'block',
    overflowX: 'auto',
    width: '100%',
    '@media (max-width: 320px)': {
      maxWidth: 310,
    },
    '@media (max-width: 767px) and (min-width: 321px)': {
      maxWidth: 350,
    },
    '@media (min-width: 768px) and (max-width: 1021px)': {
      maxWidth: 750,
    },
  },
  table: {
    borderCollapse: 'separate',
    borderSpacing: '0 10px',
  },
  empty: {
    marginTop: 100
  },
  entityAddIcon: {
    fontSize: 36,
    color: 'black',
    cursor: 'pointer',
  },
  cellHead: {
    backgroundColor: 'white',
    color: '#9B9B9B',
    height: 38,
    fontSize: 14,
    fontWeight: 'bold',
    padding: '8px 8px 8px 8px',
  },
  cellBodyIcons: {
    //borderLeft: '10px solid black',
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
  },
  cellBody: {
    backgroundColor: 'white',
    color: '#4A4A4A',
    minHeight: 72,
    border: '1px solid #FFFFFF',
    fontSize: 14,
    padding: '8px 8px 8px 8px',
  },
  lastcellBody: {
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
  },
  divIcon: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start'
  }
})



// WEBPACK FOOTER //
// ./src/common/components/TableComponent.js